import React, { useState } from "react";
import "./../styles/chracterselection.scss";

// Make sure your images are placed in /public/images or adjust paths accordingly
const characters = {
  steven: "images/avatar3-Dk8Y3DRT.svg",
  offmylawn: "images/avatar4-Bb8RIjZv.svg",
};

const CharacterSelection = ({ onCharacterSelect }) => {
  const [selectedCharacter, setSelectedCharacter] = useState("steven");
  const [playerName, setPlayerName] = useState("STEVEN THE OWL");

  const handleCharacterClick = (character) => {
    setSelectedCharacter(character);
    setPlayerName(character === "steven" ? "STEVEN THE OWL" : "OFFMYLAWN");
  };

  const handleContinue = () => {
    onCharacterSelect({ character: selectedCharacter, name: playerName });
  };

  return (
    <div className="character-selection">
      <h2>Name Select</h2>
      <input type="text" value={playerName} readOnly />

      <h2>Character Select</h2>
      <div className="characters">
        {Object.keys(characters).map((character) => (
          <div
            key={character}
            className={`character ${selectedCharacter === character ? "selected" : ""}`}
            onClick={() => handleCharacterClick(character)}
          >
            <img src={characters[character]} alt={character} />
          </div>
        ))}
      </div>

      <button onClick={handleContinue}>Continue</button>
    </div>
  );
};

export default CharacterSelection;